import React from "react";
import PropTypes from "prop-types";

const NotFound = ({ notFoundus, emptyValue, standard }) => {
  return emptyValue ? (
    <div className="box custom">
      <div className="content">
        <p>The search box seems to be empty, ouch..</p>
      </div>
    </div>
  ) : notFoundus ? (
    <div className="box custom">
      <div className="content">
        <h2>Oh noes! Your search couldn't be processed.</h2>
        <p>Please change it up a bit and try again</p>
      </div>
    </div>
  ) : standard ? (
    <div className="box custom welcome">
      <div className="content">
        <h2>Hi there, welcome to my Flickr photo search app</h2>
        <p>Please enter one ore more (comma separated) keywords into the above search box, in order to inizialise your search. Enjoy :)</p>
      </div>
    </div>
  ) : null
  };

NotFound.propTypes = {
    notFoundus: PropTypes.bool,
    emptyValue: PropTypes.bool,
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/notFoundEmpty.js